/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export const LOADING = 'LOADING'
export const CONFIRM_RELOAD = 'CONFIRM_RELOAD'
export const LOGIN = 'LOGIN'
export const BREADCRUMBS = 'BREADCRUMBS'
export const SCREEN = 'SCREEN'

import { SET_APP_LOADING, SET_CONFIRM_RELOAD, SET_BREADCRUMBS, SET_SCREEN } from './mutations'

import axios from '@/axios'

const actions = {
  [LOADING]({ commit }, loading) {
    commit(SET_APP_LOADING, loading)
  },
  [CONFIRM_RELOAD]({ commit }, confirm) {
    commit(SET_CONFIRM_RELOAD, confirm)
  },
  [LOGIN]({ commit }) {
    axios.get(`${process.env.VUE_APP_API_URL}/login`).then(
      (response) => {
        return response.data
      },
      (error) => {
        alert('ERROR')
        return Promise.reject(error)
      })
  },
  [BREADCRUMBS]({ commit }, data) {
    commit(SET_BREADCRUMBS, data)
  },
  [SCREEN]({ commit }, data) {
    commit(SET_SCREEN, data)
  }
}

export default actions
